<template>
  <div>
    <form @submit.prevent="submitcuti" class="row g-3" ref="fPh">
      <div class="col-12">
        <label>Tanggal</label>
        <input type="date" class="form-control" v-model="tanggalPH" required />
      </div>
      <div class="col-12">
        <label>Jenis</label>
        <select
          v-model="jenis"
          @change="changeJenis($event)"
          class="form-control"
        >
          <option value="full-day">Full Day</option>
          <option value="half-day">Half Day</option>
        </select>
      </div>
      <label v-if="jenis == 'half-day'">Waktu</label>
      <div class="col-6">
        <div class="input-group mb-3" v-if="jenis == 'half-day'">
          <input
            type="number"
            class="form-control"
            aria-describedby="basic-addon2"
            v-model="jam"
            min="1"
          />
          <span class="input-group-text" id="basic-addon2">Jam</span>
        </div>
      </div>
      <div class="col-6">
        <div class="input-group mb-3" v-if="jenis == 'half-day'">
          <input
            type="number"
            class="form-control"
            aria-describedby="basic-addon2"
            v-model="menit"
            min="0"
          />
          <span class="input-group-text" id="basic-addon2">Menit</span>
        </div>
      </div>
      <div class="col-12">
        <label>Keterangan</label>
        <textarea
          class="form-control"
          cols="30"
          rows="10"
          v-model="keterangan"
          required
        ></textarea>
      </div>
      <div class="col-12">
        <button class="btn btn-primary float-end" type="submit">Ajukan</button>
        <a @click="$router.go(-1)" class="btn btn-warning float-end mx-1"
          >Kembali</a
        >
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data: function () {
    return {
      idpeg: null,
      listLibur: [],
      selectedIdLibur: "00",
      keterangan: null,
      tanggalPH: null,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("key"),
      },
      tanggalLibur: null,
      jenis: null,
      jam: 1,
      menit: 0,
      concatTime: null,
    };
  },
  mounted() {
    this.idpeg = localStorage.getItem("id");
  },
  methods: {
    changeJenis(event) {
      this.jenis = event.target.value;
      if (this.jenis == "full-day") {
        this.concatTime = "09:00:00";
      }
    },
    submitcuti() {
      const formattedHours = String(this.jam).padStart(2, "0");
      const formattedMinutes = String(this.menit).padStart(2, "0");
      const formattedSeconds = "00";

      if (this.jenis == "full-day") {
        this.concatTime = "09:00:00";
      } else {
        this.concatTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      }
      try {
        axios
          .post(
            this.UrlApi + "storelibur",
            {
              id_pegawai: this.idpeg,
              tanggal: this.tanggalPH,
              keterangan: this.keterangan,
              jenis: this.jenis,
              waktu: this.concatTime,
            },
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.message != "gagal") {
              Swal.fire({
                icon: "success",
                title: "Berhasil!",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              const pesan =
                "*Pengajuan EO* :" +
                "\n" +
                "*Nama* : " +
                "\n" +
                localStorage.getItem("nama") +
                "\n" +
                "*Tanggal* : " +
                "\n" +
                this.tanggalPH +
                "\n" +
                "*Jenis* : " +
                "\n" +
                this.jenis +
                "\n" +
                "*Waktu Diambil* : " +
                "\n" +
                this.jam +
                " Jam " +
                this.menit +
                " Menit" +
                "\n" +
                "*Keterangan* : " +
                "\n" +
                this.keterangan +
                "\n" +
                "\n" +
                "_*Silahkan cek di aplikasi presensi untuk approve atau decline*_";
              //kirim ke group
              try {
                axios
                  .post(this.UrlApi + "postwa", {
                    group_name: "HRD info",
                    message: pesan,
                  })
                  .then(() => {
                    // console.log(res);
                    this.keterangan = null;
                    this.tanggalPH = null;
                  });
              } catch (error) {
                console.log(error);
              }
            } else {
              this.keterangan = null;
              this.tanggalPH = null;
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
